import { ITableConfig } from "@/components/table/table.model";
import { SORTING_DIR } from "@/common/models";

export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "",
      sortable: false,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "3rem",
      spanMax: "3rem",
    },
    {
      name: "File Name",
      key: "file_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "25rem",
      spanMax: "1fr",
    },
    {
      name: "Container & Folder",
      key: "container_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "15rem",
      spanMax: "1fr",
    },
    {
      name: "Storage Account",
      key: "storage_account",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "15rem",
      spanMax: "1fr",
    },
    {
      name: "Created At",
      key: "created_at",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "13rem",
      spanMax: "13rem",
    },
  ],
};
